import { Component, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FileUploadModel } from '../../models/filemodel';
import { FileService } from './file.service';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { Subject } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogClose } from '@angular/material/dialog';
import { TelemetryService } from '@infosys-it/angular-telemetry-sdk';
import { DragDirective } from './drag-drop.directive';
import { MatChipListbox, MatChipOption } from '@angular/material/chips';
import { MatButton } from '@angular/material/button';

export interface AttachData {
  attachmentList: any;
}

@Component({
  selector: 'app-attachment-dialog',
  standalone: true,
  templateUrl: './attachment-dialog.component.html',
  styleUrls: ['./attachment-dialog.component.scss'],
  animations: [
    trigger('fadeInOut', [
      state('in', style({ opacity: 100 })),
      transition('* => void', [animate(3000, style({ opacity: 0 }))]),
    ]),
  ],
  imports: [DragDirective, MatChipListbox, MatChipOption, MatButton, MatDialogClose],
})
export class AttachmentDialogComponent {
  dialogRef = inject<MatDialogRef<AttachmentDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private sanitizer = inject(DomSanitizer);
  private fileService = inject(FileService);
  private telemetryService = inject(TelemetryService);

  multiple = true;
  multiSelectFlag = false;
  fileSizeError: any;
  fileTotalSize: any;
  uploadResponse = { status: '', message: '', filePath: '' };
  private files: FileUploadModel[] = [];
  fileMerge = [];
  fileMultiMerge = [];
  filenameProgressbar: string;
  filename = [];
  fileArray = [];
  private attachData: AttachData[] = [];
  allowedFileTypes: any;
  uploadType = 'multiple';
  fileDeleteSub = new Subject();
  key: number;
  lastindex: number;
  fileNameValidation: any;

  constructor() {
    const data = this.data;

    this.allowedFileTypes = data.allowedfileType.split(',');
    this.uploadType = data.uploadType;
    this.fileNameValidation = data.fileNameValidation;
    //  console.log(this.allowedFileTypes);
  }

  /**For File Select functionality**/
  onFileSelected(event) {
    const files = event.dataTransfer ? event.dataTransfer.files : event.target.files;
    this.fileUploading(files);
  }

  /**For Drag and Drop functionality**/
  uploadFile(event) {
    const files = event;
    this.fileUploading(files);
  }

  fileUploading(files) {
    if (this.data.uploadType == 'single') {
      this.fileMerge = [];
      this.fileArray.splice(0, this.fileArray.length);
      this.filename.splice(0, this.filename.length);
    }
    this.key = 1;
    let errorFile = false;
    for (const file of files) {
      if (!this.validate(file)) {
        errorFile = true;
      }
    }

    if (!errorFile) {
      for (const file of files) {
        if (this.filename.indexOf(file.name) === -1) {
          this.fileMerge = [];
          this.fileArray.push(file);
          this.filename.push(file.name);
        } else {
          const fileArrValues = [];
          this.fileArray.forEach((fileArr) => {
            if (file.name != fileArr['name']) {
              fileArrValues.push(fileArr);
              // console.log(fileArr.file)
            }
          });
          //Override the last same name file
          delete this.fileArray;
          this.fileArray = fileArrValues;
          this.fileArray.push(file);
        }
      }
    }
  }

  validate(file: File) {
    this.fileSizeError = '';

    const fileType = this.getFileExtension(file.name);

    if (file.size > 5242880) {
      this.fileSizeError = 'Please upload maximum 5MB size only.';
      return false;
    }

    // else if(file.size > 2097152 && (fileType == 'docx' || fileType == 'pdf' ))
    // {
    //       this.fileSizeError = 'Please upload maximum 2MB size only.';
    //       return false;
    // }
    else if (!this.allowedFileTypes.includes(fileType)) {
      this.fileSizeError = `Please upload the correct format ${this.allowedFileTypes.join(',')}`;
      return false;
    } else if (!file.name.match(this.fileNameValidation['value'])) {
      this.fileSizeError = this.fileNameValidation['message'];
      return false;
    } else {
      return true;
    }

    // if (file.size > 2097152 && (fileType === 'pdf' || fileType === 'docx' || fileType === 'doc')) {
    //   this.fileSizeError = 'Please upload maximum 2MB size only.';
    //   return false;
    // }
    // else if (!(fileType.toLowerCase() === 'pdf' || fileType.toLowerCase() === 'docx' || fileType.toLowerCase() === 'doc')) {
    //   this.fileSizeError = 'Please upload the correct format doc|docx|pdf';
    //   return false;
    // }
    // else {
    //   return true;
    // }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  getFileExtension(filename) {
    return filename.split('.').pop();
  }

  removeParent(filename) {
    const FileValuesDelete = [];
    this.filename.forEach((file) => {
      if (file != filename) {
        FileValuesDelete.push(file);
      }
    });
    delete this.filename;
    this.filename = FileValuesDelete;

    const FileArrayValuesDelete = [];
    this.fileArray.forEach((file) => {
      if (file.name != filename) {
        FileArrayValuesDelete.push(file);
      }
    });
    delete this.fileArray;
    this.fileArray = FileArrayValuesDelete;
    // console.log( this.fileArray)
    this.fileSizeError = '';
  }
}
